export interface MembersModalSkeletonProps {
  rows?: number;
}

export const MembersModalSkeleton = ({
  rows = 10,
}: MembersModalSkeletonProps) => {
  return (
    <div className="flex flex-col p-2">
      {Array.from(Array(rows)).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between bg-ds-grey-600 animate-pulse p-2 gap-4"
        >
          <div className="w-1/2">
            <div className="bg-ds-natural-50 h-6 w-full rounded-md" />
          </div>
          <div className="w-1/3 flex justify-end">
            <div className="bg-ds-natural-50 h-6 w-full rounded-md" />
          </div>
          <div className="flex-auto flex items-center justify-end">
            <div className="bg-ds-natural-50 rounded-full w-8 h-8" />
          </div>
        </div>
      ))}
    </div>
  );
};
